import React, { useEffect } from "react";
import { createContext, useContext, useState } from "react";
import { IUserModel } from "../IRequestModel/IUserModel";
import { useUserContext } from "./UserContext";
import { GetPermissionByEmpId, GetRolePermission } from "../Services/RoleServices";
import { GetAllDynamic } from "../Services/DynamicService";
import { GetEcatalogSystemStatus } from "../Services/e-pro/EcatalogService";

//const _userData = JSON.parse(localStorage?.getItem("userData") || "null") || { employeeData: {} };


// const employeeData = _userData.employeeData;
// const initialSession: IUserModel = employeeData;

// type ECatalogRoleContextType = {
//   roleData: any;
//   setECatalogRole: (data: any) => void;
//   loadUserData: async() => void,
// };

export const ECatalogContext = createContext({
  roleData: null,
  canAccess: false,
  canEdit: false,
  isSystemClosed: false,
  systemClosedTitle: "",
  systemClosedMessage: "",
  //setCanAccess: () => null,
  //setCanEdit: () => null,
  checkPermissionUser: async () => {},
}); //createContext<ECatalogRoleContextType | null>(null);

export const useECatalogContext = () => useContext(ECatalogContext);

export const ECatalogContextProvider: React.FC = (props) => {
  const [userData] = useUserContext();
  const [loading,setLoading]=useState(false);
  const [roleData, setECatalogRole] = useState<any | null>(null);
  const [canAccess, setCanAccess] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [isSystemClosed, setIsSystemClosed] = useState(false);
  const [systemClosedTitle, setSystemClosedTitle] = useState("");
  const [systemClosedMessage, setSystemClosedMessage] = useState("");

  const checkSystemStatus = async () => {
    const status = await GetEcatalogSystemStatus();
    setIsSystemClosed(status?.isClosed === true);
    setSystemClosedTitle(status?.title || "");
    setSystemClosedMessage(status?.message || "");
  };

  const checkPermissionUser = async () => {
    //const canEdit = await CheckCanAdminEditCompletedMemo();
    setLoading(true)
    const dataPermission = await GetPermissionByEmpId({
      EmployeeId: userData.EmployeeId,
    });

    let isAdmin: boolean = false;
    let canAccess: boolean = false;
    let canEdit: boolean = false;
    let permissions: any[] = await GetRolePermission();
    let roles: any[] = await GetAllDynamic("Roles/GetAll", undefined);

    if (dataPermission) {
      let listToCheck = dataPermission.map((perm) => {
        let getRole = roles.filter(x => x.RoleId === perm.roleId);
        return getRole[0];
      });

      console.log(listToCheck)

      var checkIsAdminRole = listToCheck.filter(x =>  x.RoleId === 1 || x.NameTh.includes("ผู้ขอซื้อ"));
      if (checkIsAdminRole.length > 0){
          canEdit = true;
          canAccess = true;
         
      }else{
          var checkIsAVLC = listToCheck.filter(x => x.NameTh.includes("AVL-C"));
          if (checkIsAVLC.length <= 0)
          {
            canAccess = true;
          }
      }

      setCanAccess(canAccess);
      setCanEdit(canEdit)
      //setCanEdit(false);
      setECatalogRole(listToCheck);
    }

    setLoading(false);

  };

  useEffect(() => {
    checkPermissionUser();
    checkSystemStatus();
  }, []);

  return (
    <ECatalogContext.Provider value={{roleData, canAccess, canEdit, isSystemClosed, systemClosedTitle, systemClosedMessage,  checkPermissionUser}}>
      {props.children}
    </ECatalogContext.Provider>
  );
};
